import Head from 'next/head';
import {useTranslation} from 'next-i18next';
import type {GetServerSideProps} from 'next';
import {QueryClient} from '@tanstack/react-query';
import DataProtectionHeroSection from 'src/components/data-protection/DataProtectionHeroSection';
import DataProtectionFAQSection from 'src/components/data-protection/DataProtectionFAQSection';
import {WidthContainer} from 'src/components/landing/LandingComponents';
import {nsFAQ, nsTranslation, nsWebsite} from 'src/services/i18n';
import LandingHeader from 'src/components/landing/LandingHeader';
import LandingFooter from 'src/components/landing/LandingFooter';
import {getPublicLayout} from 'src/components/PublicLayout';
import RowOfLogos from 'src/pages/landing-page/RowOfLogos';
import ssrTranslations from 'src/utils/ssrTranslations';
import getTitle from 'src/utils/getTitle';

const DataProtection = () => {
  const {t} = useTranslation();

  return (
    <>
      <Head>
        <title>{getTitle(t('website.data protection'))}</title>
      </Head>

      <LandingHeader />

      <DataProtectionHeroSection />
      <DataProtectionFAQSection />

      <WidthContainer className="flex flex-col items-center mb-16">
        <p className="text-center text-base">{t('website.company logos description')}</p>

        <RowOfLogos />
      </WidthContainer>

      <LandingFooter />
    </>
  );
};

DataProtection.isPublicPage = true;

DataProtection.getLayout = getPublicLayout;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const queryClient = new QueryClient();

  return {props: {...(await ssrTranslations(context, queryClient, [nsTranslation, nsWebsite, nsFAQ]))}};
};

export default DataProtection;
